import * as angular from 'angular';
import {IController} from "angular";

export class ServicesAssignRouteTableCtrl implements IController {
  list: any;
  extraVolume: any;
  loading: any;
  onAssign: Function;

  private defaultCountValue: any;
  private counter: any;
  public isMobile: boolean;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {
    this.defaultCountValue = 3;
  }

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-md');
  };

  setEvents() {
    const div1 = document.getElementById('services-assign-route-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('services-assign-route-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignRouteTable', {
    bindings: {
      list: '<',
      columns: '<',
      extraVolume: '<?',
      loading: '<?',
      onAssign: '&'
    },
    template: require('./services-assign-route-table.html').default,
    controller: ServicesAssignRouteTableCtrl
  });
